<section class="container-style">
  <div class="row">
    <form novalidate [formGroup]="formPurchaseProjection">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="purchaseProjectionContract.userNameCreate"
              [createDate]="purchaseProjectionContract.createDate"
              [userNameUpdate]="purchaseProjectionContract.userNameUpdate"
              [updateDate]="purchaseProjectionContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-6 col-12">
            <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch" [required]="true"
              [recovery]="true" (onChangeSelect)="changeBranch($event)">
            </app-custom-select>
          </div>
          <div class="col-lg-4 col-md-7 col-sm-6 col-12">
            <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [required]="true"
              [recovery]="true" [list]="listArticles" (onChangeSelect)="getPurchaseProjectionByKeys($event)">
            </app-custom-autocomplete>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-3 col-6">
            <app-custom-input-decimal formControlName="quantity" [required]="true"
              [labelText]="'Cantidad'"></app-custom-input-decimal>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-3 col-6">
            <app-custom-datepicker formControlName="datePurchaseProjection" [required]="true"
              [labelText]="'Fecha Entrada'"></app-custom-datepicker>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-2">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined" (onClick)="send()">
            </app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>